"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteRequestDataType = void 0;
var AuthSuiteRequestDataType;
(function (AuthSuiteRequestDataType) {
    AuthSuiteRequestDataType["CLIENT_ID"] = "clientId";
    AuthSuiteRequestDataType["COUNTRY_CODE"] = "countryCode";
})(AuthSuiteRequestDataType = exports.AuthSuiteRequestDataType || (exports.AuthSuiteRequestDataType = {}));
